module.exports = __webpack_public_path__ + "static/flags/MM-a3baf3373690cfd65719ca45ad93f984.gif";